// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialActionsMenu-cls1_ATn","cls2":"SocialActionsMenu-cls2_UHa SocialActionsMenu-cls1_ATn"};